import signUpActions from '../actionTypes/signUpActions';

const initialState = {
  isLoading: true,
  isSigningUp: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case signUpActions.userSignUp:
      return { ...state, isSigningUp: true };
    case signUpActions.userSignUpSuccess:
      return {
        ...state,
        ...action.payload,
        isSigningUp: false,
        signUpSuccess: true
      };
    case signUpActions.userSignUpFailed:
      return {
        ...state,
        ...action.payload,
        isSigningUp: false
      };
    case signUpActions.resetToInitialState:
      return initialState;
    default:
      return state;
  }
};
